import { render, staticRenderFns } from "./ReportImprovementProposedEmployees.vue?vue&type=template&id=96da2c6a&"
import script from "./ReportImprovementProposedEmployees.vue?vue&type=script&lang=js&"
export * from "./ReportImprovementProposedEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QTable,QIcon,QTr,QTh,QTd,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QTable,QIcon,QTr,QTh,QTd,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
